import { ReactElement } from 'react';

import { Tooltip } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../translations';

type AddMedicineToPrescriptionTooltipProps = {
   readonly children: ReactElement;
};

const AddMedicineToPrescriptionTooltip = (props: AddMedicineToPrescriptionTooltipProps): JSX.Element => {
   return (
      <Tooltip content={medicineSelectorTranslationKeys.addMedicineToPrescription} testId={'addMedicineToPrescription'}>
         {props.children}
      </Tooltip>
   );
};

export { AddMedicineToPrescriptionTooltip };
